/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Alert, Button, Heading, HStack, Stack, Text} from '@chakra-ui/react'
import {AlertIcon} from '../icons'
import {noop} from '../../utils/utils'
import ResetPasswordFields from '../forms/reset-password-fields'

const ResetPasswordForm = ({submitForm, clickSignIn = noop, form}) => {
    return (
        <Fragment>
            <Stack spacing={8} data-testId="reset-password-form">
                <Heading color="stokkePink.dark" textStyle="Regular 45XLarge">
                    <FormattedMessage
                        defaultMessage="Reset Password"
                        id="reset_password_form.title.reset_password"
                    />
                </Heading>
                <Text textStyle="Regular Medium">
                    <FormattedMessage
                        defaultMessage="Enter your email to receive instructions on how to reset your password"
                        id="reset_password_form.message.enter_your_email"
                    />
                </Text>
                <form onSubmit={form.handleSubmit(submitForm)} data-testid="sf-auth-modal-form">
                    <Stack spacing={8}>
                        {form.formState.errors.global && (
                            <Alert status="error">
                                <AlertIcon color="stokkeFunctional.red" boxSize={4} />
                                <Text fontSize="sm" ml={3}>
                                    {form.formState.errors.global.message}
                                </Text>
                            </Alert>
                        )}
                        <ResetPasswordFields form={form} />
                        <Button
                            type="submit"
                            onClick={() => form.clearErrors('global')}
                            isLoading={form.formState.isSubmitting}
                        >
                            <FormattedMessage
                                defaultMessage="Reset Password"
                                id="reset_password_form.button.reset_password"
                            />
                        </Button>
                    </Stack>
                </form>
                <HStack spacing={2} align="flex-start" justify="center">
                    <Text textStyle="Regular Medium">
                        <FormattedMessage
                            defaultMessage="Or return to"
                            id="reset_password_form.message.return_to_sign_in"
                            description="Precedes link to return to sign in"
                        />
                    </Text>
                    <Button variant="link" onClick={clickSignIn}>
                        <FormattedMessage
                            defaultMessage="Sign in"
                            id="reset_password_form.action.sign_in"
                        />
                    </Button>
                </HStack>
            </Stack>
        </Fragment>
    )
}

ResetPasswordForm.propTypes = {
    submitForm: PropTypes.func,
    clickSignIn: PropTypes.func,
    form: PropTypes.object
}

export default ResetPasswordForm
